import { format } from 'date-fns'
import { Availability } from '@customTypes/Availabilities'
import { analyticsEventSelectedAppointment } from 'src/services/analytics'
import { useChoiceDispatch, setSelectedBookable, setAppointmentDuration } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import { shortenTimeString } from '@screens/Appointment/helpers/shortenTimeString'
import { useCreateBookingForExistingPatient } from './useCreateBookingForExistingPatient'

export const useSelectTimeslot = () => {
  const dispatch = useChoiceDispatch()
  const { resetCalendarError } = useCreateBookingForExistingPatient()
  const { clinicId: defaultClinicId } = useConfig()

  const selectTimeslot = (availability: Availability, clinicId?: string) => {
    const date = format(new Date(availability.originalStartTimestamp), 'yyyy-MM-dd')
    const time = availability.start
    const maxDurationInMinutes = availability.maxDurationInMinutes
    const practitionersForSlot = availability.practitionerReferenceIds
    const originalStartTimestamp = availability.originalStartTimestamp

    const shortenedTimeString = shortenTimeString(time)
    dispatch(
      setSelectedBookable({
        day: date,
        date,
        time: shortenedTimeString,
        practitionersForSlot,
        originalStartTimestamp,
        clinicId: clinicId || defaultClinicId,
      })
    )
    resetCalendarError()
    dispatch(setAppointmentDuration(maxDurationInMinutes || 0))
    analyticsEventSelectedAppointment(shortenedTimeString)
  }

  return selectTimeslot
}
